"use client";

import { useEffect } from "react";

export const VConsole = () => {
  useEffect(() => {
    let vConsoleInstance: { destroy: () => void } | null = null;

    import("vconsole").then((module) => {
      const VConsole = module.default;
      vConsoleInstance = new VConsole({
        theme: "dark",
        // `network` plugin omitted: vconsole@3.15.1's fetch monkey-patch is
        // incompatible with Next 16 / Turbopack — its _flushLogs trips on
        // requests Next's wrapper completes outside vconsole's tracking map,
        // throwing `Cannot read properties of undefined (reading 'update')`.
        // Use Chrome DevTools (remote inspect via chrome://inspect) for
        // network panel on mobile until vconsole ships a fix.
        defaultPlugins: ["system", "element", "storage"],
      });
    });

    return () => {
      vConsoleInstance?.destroy();
    };
  }, []);

  return null;
};
